import { createApp } from 'vue'
import App from './App.vue'
import router from './router/router.js'
import './assets/css/reset.css'
import store from './store/products.js'

createApp(App)
    .use(router)
    .use(store)
    .mount('#app')
